"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldChipCoreInputs = void 0;
class EmeraldChipCoreInputs {
    constructor() {
        this.id = `Chip${Math.random().toString()}`;
    }
}
exports.EmeraldChipCoreInputs = EmeraldChipCoreInputs;
//# sourceMappingURL=chip.inputs.js.map